<template>
    <div class="result-hero-wrapper">
        <div class="container">
            <div class="col result-hero-container justify-content-center">
                <div class="result-hero-details">
                    <div class="details">
                        <div class="title">
                            <span class="greetingDetail"> {{ $t('results.heroBanner.fraudDecline') }}. </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
